<template>
  <div :class="getClassName" class="matrix_selectOption">
    <div class="matrix_selectOptionName">
      {{ name }}
    </div>
    <SelectOption
      :id="getId"
      v-model="value"
      :options="getQuantities"
      :settings="settings"
    />
  </div>
</template>
<script>
import { useQuantityFieldStore } from "@/stores/modules/quantityField";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { mapState, mapActions } from "pinia";

import { i18n } from "../../i18n.js";

export default {
  computed: {
    ...mapState(useWebproductStore, [
      "getQuantitySelection",
      "getPersonalizationQuantityWithPrice",
      "getHideSearchBoxInPoptext",
      "getSelector"
    ]),
    ...mapState(useChangeOptionsStore, ["getPersonalizationCustomPrices"]),
    ...mapState(useQuantityFieldStore, ["getQuantityField"]),

    getId: function () {
      return this.getSelector + "_matrix_quantitySelectionId";
    },
    value: {
      get: function () {
        return this.getQuantityField;
      },
      set: function (newValue) {
        this.setQuantityField(newValue);
      }
    },
    name: () => {
      return i18n.t("Fixed quantities");
    },
    settings: function () {
      var hideOptions = {};
      if (this.getHideSearchBoxInPoptext) {
        hideOptions = { minimumResultsForSearch: -1 };
      }
      return { ...hideOptions };
    },
    getQuantities: function () {
      var qties = this.getQuantitySelection.split(",");
      var pcsString = i18n.t("Pcs.");
      var prices = [];
      if (this.getPersonalizationQuantityWithPrice) {
        prices = this.getPersonalizationCustomPrices;
      }
      return qties.map(el => {
        var text = el + " " + pcsString;
        if (this.getPersonalizationQuantityWithPrice) {
          text = el + " " + pcsString + " - " + prices[el];
        }
        return {
          text,
          id: el
        };
      });
    }
  },
  methods: { ...mapActions(useQuantityFieldStore, ["setQuantityField"]) }
};
</script>
